var colors = {
  white: '#fff',
  black: '#1c1c1c',
  grey: {
    lightest: '#fafafa',
    light: '#efefef',
    "default": '#ebebeb',
    dark: '#ddd',
    darker: '#acacac',
    darkest: '#595959'
  },
  blue: {
    lightest: '#e5efff',
    light: '#6ba4ff',
    "default": '#0063ff',
    dark: '#0158e2'
  },
  green: {
    lightest: '#c4e1d7',
    light: '#5caf93',
    "default": '#138760',
    dark: '#0c5f43'
  },
  yellow: {
    lightest: '#fff1c3',
    light: '#fddd70',
    "default": '#ffc810',
    dark: '#e89c2e'
  },
  red: {
    lightest: '#f3cfc5',
    light: '#e67355',
    "default": '#cf3c16',
    dark: '#b12d0b'
  },
  purple: {
    lightest: '#585c74',
    light: '#4b4f64',
    "default": '#3d4153',
    dark: '#353a48'
  }
};

export { colors };
//# sourceMappingURL=gaudi-tokens.esm.js.map
